export const unclusteredPointLayer: any = {
  id: "blackPin",
  type: "symbol",
  source: "blackPin",
  layout: {
    "icon-image": ["get", "icon"],
    "icon-size": 1,
    "icon-allow-overlap": true,
    "text-field": ["get", "price"],
    "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
    "text-size": 12,
    "text-offset": [0, -0.8],
    "text-anchor": "top",
    "text-allow-overlap": true,
    "symbol-sort-key": ["get", "sortKey"], // ✅ this controls z-index
    "symbol-z-order": "auto" // or "viewport-y" for vertical stacking
  },
  paint: {
    "text-color": "#f5f5f5",
    "text-halo-width": 1
  },
};

export const CenteredPinLayer: any = {
  id: "centered-point",
  type: "symbol",
  source: "center-pin",
  layout: {
    "icon-image": ["get", "icon"],
    "icon-size": 1.1,
    "icon-allow-overlap": true,
    "text-field": ["get", "price"],
    "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
    "text-size": 13,
    "text-offset": [0, -0.8],
    "text-anchor": "top",
    "text-allow-overlap": true
    // "symbol-z-order": "viewport-y",
  },
  paint: {
    "text-color": "#f5f5f5",
    // 'text-halo-color': '#ffffff',
    "text-halo-width": 1
  }
};
